export default "__VITE_ASSET__BGJ64B_q__"